import { useComponentStylingType3 } from "@/scripts/ui/ComponentStylingType3";
import { useButtonInteraction } from "@/scripts/ui/ButtonInteraction";
import { useComponentDisplayData } from "@/scripts/ui/ComponentDisplayData";
import { useComponentData } from "@/scripts/ui/ComponentData";
export function useAccordion2() {
  const data = {};
  data.component = "AccordionComponent";
  let attr = (data.attributes = {});
  attr.componentData = useComponentData();
  attr.componentData.content = "CofigurableButtonContent1Component";
  attr.componentData.styling = useComponentStylingType3();
  attr.componentData.interaction = useButtonInteraction();
  attr.componentData.display = useComponentDisplayData(); 
  attr.componentData.children = []; 

  return data;
}
